import React, { useState, useEffect, useRef } from 'react'

import styles from './product.module.scss'
import { Link, useHistory } from 'react-router-dom'
import { ROUTES, PERMISSIONS, STATUS_PRODUCT, IMAGE_DEFAULT, ACTION } from 'consts'
import { compareCustom, formatCash, generatorTreeNodeCategories, tableSum } from 'utils'
import moment from 'moment'
import { compare } from 'utils'
import { useDispatch } from 'react-redux'

import {
  Switch,
  Slider,
  notification,
  Button,
  Modal,
  Table,
  Input,
  Row,
  Col,
  Space,
  Popconfirm,
  TreeSelect,
  Tag,
} from 'antd'

//components
import SettingColumns from 'components/setting-columns'
import ExportProduct from 'components/ExportCSV/ExportProduct'
import ImportProducts from 'components/import-products'
import TitlePage from 'components/title-page'
import FilterDate from 'components/filter-date'
import FilterRegion from 'components/filter-region'

//icons
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons'

//apis
import { getCategories } from 'apis/category'
import { getSetMenu, deleteSetMenu } from 'apis/set-menu'
import { getSignedUrl } from 'utils/upload'

export default function SetMenu() {

  const columnsProduct = [
    {
      title: 'STT',
      key: 'stt',
    },
    {
      title: 'Hình ảnh',
      key: 'image',
    },
    {
      title: 'Tên món ăn',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Quốc gia',
      dataIndex: 'country_ids',
      key: 'country_ids',
    },
    {
      title: 'Khu Vực',
      dataIndex: 'region_ids',
      key: 'region_ids',
    },
    {
      title: 'Hành động',
      key: 'action',
    },
  ];

  const dispatch = useDispatch()
  const history = useHistory()
  const typingTimeoutRef = useRef(null)
  const KEY_FILTER = 'productFilter'
  const filters = localStorage.getItem(KEY_FILTER) && JSON.parse(localStorage.getItem(KEY_FILTER))

  const [loading, setLoading] = useState(true)
  const [valueSearch, setValueSearch] = useState(filters ? filters.name || '' : '')
  const [paramsFilter, setParamsFilter] = useState(
    filters ? { ...filters } : { page: 1, page_size: 20 }
  )
  const [products, setProducts] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [categories, setCategories] = useState([])
  const [columns, setColumns] = useState([])
  const [countProduct, setCountProduct] = useState(0)

  const _getCategories = async () => {
    try {
      const res = await getCategories({ page: 1, page_size: 200, parent: true })
      if (res.status === 200)
        setCategories(res.data.data.map((e) => generatorTreeNodeCategories(e)))
    } catch (error) {
      console.log(error)
    }
  }

  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys)
  }


  const columnsVariant = [
    {
      title: 'Hình ảnh',
      key: 'image',
    },
    {
      title: 'Mã thuộc tính',
      dataIndex: 'sku',
    },
    {
      title: 'Tên thuộc tính',
      dataIndex: 'title',
    },
    // {
    //   title: 'Giá bán sỉ',
    //   render: (text, record) =>
    //     record.prices && record.prices.length ? (
    //       <ModalViewBulkPrices bulkPrices={record.prices || []} />
    //     ) : (
    //       ''
    //     ),
    // },
    {
      title: 'Giá bán',
      render: (text, record) =>
        record.prices && record.prices.length ? formatCash(record.prices[0].price || 0) : 0,
    },
    {
      title: 'Hiển thị',
      key: 'is_active_variant',
    },
  ]

  const onSearch = (e) => {
    setValueSearch(e.target.value)

    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      const value = e.target.value

      if (value) paramsFilter.name = value
      else delete paramsFilter.name

      setParamsFilter({ ...paramsFilter, page: 1 })
    }, 750)
  }

  const _getProductsToExport = async () => {
    try {
      dispatch({ type: ACTION.LOADING, data: true })
      const res = await getSetMenu();
      if (res.status === 200) {
        dispatch({ type: ACTION.LOADING, data: false })
        return res.data.data
      }
      dispatch({ type: ACTION.LOADING, data: false })
      return []
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
      return []
    }
  }

  const getAllProduct = async () => {
    setLoading(true)
    setProducts([])

    try {
      const res = await getSetMenu({ ...paramsFilter })
      if (res.status === 200) {
        // console.log("getSetMenu", res.data.data);
        let products = await Promise.all(res.data.data.map(async (e) => {
          let images = await Promise.all(e.image_urls.length ? e.image_urls.map(async (img) => {
            return await getSignedUrl(img);
          }) : []);

          console.log("images", images)

          return ({
            ...e,
            image_urls: images,
            // image: e.variants.length ? e.variants[0].image : [],
            // price: e.variants.length ? e.variants[0].price : 0,
            // price_no_tax: e.variants.length ? e.variants[0].price_no_tax : 0,
          });
        }));

        setProducts(
          products
        )
        setCountProduct(res.data.count)
      }

      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const _deleteProduct = async (id) => {
    try {
      setLoading(true)
      const res = await deleteSetMenu([id])
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xoá set menu thành công!' })
          getAllProduct()
        } else
          notification.error({
            message: res.data.message || 'Xoá set menu thất bại, vui lòng thử lại!',
          })
      } else
        notification.error({
          message: res.data.message || 'Xoá set menu thất bại, vui lòng thử lại!',
        })
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const onChangeCategoryValue = async (id) => {
    if (id && id.length) paramsFilter.category_id = id.join('---')
    else delete paramsFilter.category_id
    setParamsFilter({ ...paramsFilter, page: 1 })
  }

  const saveFiltersToLocalStorage = () => {
    const PARAMS_FILTER_DATE = [
      'from_date',
      'to_date',
      'today',
      'yesterday',
      'this_week',
      'last_week',
      'last_month',
      'this_month',
      'this_year',
      'last_year',
    ]

    const paramsFilterStorage = { ...paramsFilter }

    const keysParamsFilter = Object.keys(paramsFilterStorage)
    for (let i = 0; i < keysParamsFilter.length; i++)
      if (PARAMS_FILTER_DATE.includes(keysParamsFilter[i]))
        delete paramsFilterStorage[keysParamsFilter[i]]

    //save filters to localStorage
    localStorage.setItem(KEY_FILTER, JSON.stringify({ ...paramsFilterStorage }))
  }

  useEffect(() => {
    if (history.location.state) {
      if (history.location.state.filter && history.location.state.filter.name)
        setValueSearch(history.location.state.filter.name)
    }

  }, [])

  useEffect(() => {
    getAllProduct()
    saveFiltersToLocalStorage()
  }, [paramsFilter])

  useEffect(() => {
    _getCategories();
    setColumns([...columnsProduct]);
  }, [])

  return (
    <>
      <div className={`${styles['promotion_manager']} ${styles['card']}`}>
        <TitlePage title="Danh sách món ăn">
          <Space>
            <Link to={{ pathname: ROUTES.SETMENU_CREATE, description: 'món ăn' }}>
              <Button size="large" type="primary" icon={<PlusCircleOutlined />}>
                Thêm món ăn
              </Button>
            </Link>
          </Space>
        </TitlePage>

        <Row gutter={[16, 16]} style={{ marginTop: 15 }}>
          <Col xs={24} sm={24} md={24} lg={10} xl={10}>
            <Input
              size="large"
              style={{ width: '100%' }}
              name="name"
              value={valueSearch}
              onChange={onSearch}
              className={styles['orders_manager_content_row_col_search']}
              placeholder="Tìm kiếm theo tên món ăn"
              allowClear
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={10} xl={10}>
            <FilterRegion
              width_size={'100%'}
              setParamsFilter={setParamsFilter}
              paramsFilter={paramsFilter}
              title="product"
            />
          </Col>
        </Row>



        <Row
          justify="space-between"
          wrap={false}
          style={{ marginTop: 20, marginBottom: 10, width: '100%' }}
        >
          <Space size="middle" style={{ visibility: !selectedRowKeys.length && 'hidden' }}>

          </Space>
        </Row>

        <div className={styles['view_product_table']}>
          <Table
            style={{ width: '100%' }}
            rowSelection={{
              selectedRowKeys,
              onChange: onSelectChange,
            }}
            rowKey="product_id"

            columns={columns.map((column) => {
              if (column.key === 'stt')
                return {
                  ...column,
                  render: (text, record, index) =>
                    (paramsFilter.page - 1) * paramsFilter.page_size + index + 1,
                }

              if (column.key === 'name')
                return {
                  ...column,
                  render: (text, record) => (
                    <Link
                      to={{ pathname: ROUTES.SETMENU_UPDATE, state: record, description: 'món ăn' }}
                    >
                      {text}
                    </Link>
                  ),
                  sorter: (a, b) => compare(a, b, 'name'),
                }

              if (column.key === 'image')
                return {
                  ...column,
                  render: (text, record) => {
                    console.log("record", record);
                    return (
                      <img
                        style={{ width: 80, height: 80 }}
                        src={record.image_urls.length ? record.image_urls[0] : IMAGE_DEFAULT}
                        alt=""
                      />

                    )
                  }
                }

              if (column.key === 'country_ids')
                return {
                  ...column,
                  render: (text, record) =>
                    record.country_infos && (
                      <Space wrap={true}>
                        {record.country_infos.map((country, index) => (
                          <Tag key={index} closable={false}>
                            {country.name}
                          </Tag>
                        ))}
                      </Space>
                    ),
                }

              if (column.key === 'region_ids')
                return {
                  ...column,
                  render: (text, record) =>
                    record.country_infos && (
                      <Space wrap={true}>
                        {record.region_infos.map((region, index) => (
                          <Tag key={index} closable={false}>
                            {region.name}
                          </Tag>
                        ))}
                      </Space>
                    ),
                }

              if (column.key === 'category')
                return {
                  ...column,
                  render: (text, record) =>
                    record.category_info && (
                      <Space wrap={true}>
                        {record.category_info.map((category, index) => (
                          <Tag key={index} closable={false}>
                            {category.name}
                          </Tag>
                        ))}
                      </Space>
                    ),
                }
              // if (column.key === 'create_date')
              //   return {
              //     ...column,
              //     sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
              //     render: (text, record) =>
              //       record.create_date && moment(record.create_date).format('DD-MM-YYYY HH:mm'),
              //   }



              if (column.key === 'action')
                return {
                  ...column,
                  render: (text, record) => (
                    <Popconfirm
                      title="Bạn có muốn xoá set menu này không?"
                      okText="Đồng ý"
                      cancelText="Từ chối"
                      onConfirm={() => _deleteProduct(record.product_id)}
                    >
                      <DeleteOutlined style={{ color: 'red', fontSize: 18, cursor: 'pointer' }} />
                    </Popconfirm>
                  ),
                }

              return column
            })}
            loading={loading}
            dataSource={products}
            size="small"
            pagination={{
              position: ['bottomLeft'],
              current: paramsFilter.page,
              defaultPageSize: 20,
              pageSizeOptions: [20, 30, 40, 50, 60, 70, 80, 90, 100],
              showQuickJumper: true,
              onChange: (page, pageSize) =>
                setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
              total: countProduct,
            }}
          />
        </div>
      </div>
    </>
  )
}
